export default __webpack_public_path__ + "static/media/Maduro-1Closed.aa9246fd.jpg";